export default {
  data() {
    return {
      localError: null
    };
  },

  computed: {
    computedError() {
      if (!this.isChild || !this.parentForm) return null;
      if (this.name != null) return this.parentForm.getFirstError(this.name);
      else if (this.isFormGroup) {
        var error = null;
        for (var i = 0; i < this.fields.length; i++)
          if ((error = this.parentForm.getFirstError(this.fields[i].name)))
            return error;
      }
      return null;
    },

    hasComputedError() {
      return this.computedError != null;
    },

    invalidFeedback() {
      return this.localError ? this.localError : this.computedError;
    },

    hasInvalidFeedback() {
      return this.localError != null || this.hasComputedError;
    }
  },

  methods: {
    clearError() {
      this.localError = null;
      if (this.name != null && this.parentForm) {
        this.parentForm.clearError(this.name);
      }
    },

    setError(error) {
      this.localError = error;
    }
  }
};
